import React, { useState } from 'react';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import { ReactComponent as EyeOffIcon } from '../../assets/icons/eye-off.svg';

type PasswordCellProps = {
  password: string;
  mask?: string;
};

const PasswordCell: React.FC<PasswordCellProps> = ({
  password,
  mask = '••••••••',
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="position-relative">
      <span
        className="d-block pe-5 font-monospace"
        style={{ userSelect: visible ? 'text' : 'none' }}
      >
        {visible ? password : mask}
      </span>

      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setVisible((v) => !v);
          }
        }}
        className="position-absolute top-50 end-0 translate-middle-y btn p-0 border-0 bg-transparent"
        style={{ width: 28, height: 28, display: 'grid', placeItems: 'center' }}
        aria-label={visible ? 'パスワードを隠す' : 'パスワードを表示'}
        aria-pressed={visible}
        title={visible ? '隠す' : '表示'}
      >
        {visible ? (
          <EyeIcon width={18} height={18} />
        ) : (
          <EyeOffIcon width={18} height={18} />
        )}
      </button>
    </div>
  );
};

export default PasswordCell;
